export default __webpack_public_path__ + "static/media/AIA_LI.446dcc97.png";